export default __webpack_public_path__ + "static/media/mohsinChheena.ec13cc03.JPG";